/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { OverviewView } from '@midas/shared/common';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as OverviewViewActions from './overview-views.actions';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { ViewsLocations } from 'libs/overview/shell/src/lib/overview-views/views-filter/locations.interface';

export const OVERVIEW_VIEW_KEY = 'overviewview';

export interface OverviewViewState {
  views: EntityState<OverviewView>;
  locations: ViewsLocations[];
  loaded: boolean;
}

export const overviewViewAdapter = createEntityAdapter<OverviewView>();

const initialState: OverviewViewState = {
  views: overviewViewAdapter.getInitialState(),
  locations: [],
  loaded: false,
};

export const OverviewViewsFeature = createFeature({
  name: OVERVIEW_VIEW_KEY,
  reducer: createReducer(
    initialState,
    on(OverviewViewActions.queryOverviewViews, (state): OverviewViewState => {
      return {
        ...state,
        loaded: false,
      };
    }),
    on(OverviewViewActions.queryOverviewViewsSuccess, (state, { carts, locations }): OverviewViewState => {
      return {
        ...state,
        locations: locations,
        views: overviewViewAdapter.setAll(carts, state.views),
        loaded: true,
      };
    }),
    on(OverviewViewActions.queryOverviewViewBySearchValue, (state): OverviewViewState => {
      return {
        ...state,
        loaded: false,
      };
    }),
    on(OverviewViewActions.queryOverviewViewBySearchValueSuccess, (state, { carts }): OverviewViewState => {
      state = {
        ...state,
        views: overviewViewAdapter.removeAll(state.views),
        loaded: false,
      };

      state = {
        ...state,
        views: overviewViewAdapter.setAll(carts, state.views),
        loaded: false,
      };

      return {
        ...state,
        views: overviewViewAdapter.setAll(carts, state.views),
        loaded: true,
      };
    }),
    on(OverviewViewActions.queryOverviewViewGetLocations, (state): OverviewViewState => {
      return {
        ...state,
        loaded: false,
      };
    }),
    on(OverviewViewActions.queryOverviewViewGetLocationsSuccess, (state, { locations }): OverviewViewState => {
      return {
        ...state,
        locations,
        loaded: false,
      };
    }),
  ),
});
